/**
 * Realtime message bus used by the SpaceTimeDB bridge.
 * This file intentionally no longer owns socket connection lifecycle.
 */

import { createLogger } from "../logger";

const logger = createLogger("realtime-message-bus");

type MessageHandler = (message: any) => void;
const messageHandlers = new Map<string, MessageHandler>();

export function registerMessageHandler(
  messageType: string,
  handler: MessageHandler,
): void {
  messageHandlers.set(messageType, handler);
}

export function unregisterMessageHandler(messageType: string): boolean {
  return messageHandlers.delete(messageType);
}

export function dispatchLocalMessage(message: any): void {
  const messageType = message?.t;

  if (!messageType) {
    logger.warn("[BUS] Received message without type field:", message);
    return;
  }

  const handler = messageHandlers.get(messageType);
  if (!handler) {
    logger.warn(`[BUS] No handler registered for message type: ${messageType}`);
    return;
  }

  handler(message);
}

export function setupConsoleRedirection(
  originalConsoleLog: typeof console.log,
): void {
  console.log = (...args) => {
    originalConsoleLog.apply(console, args);
  };
}

export function getRegisteredMessageTypes(): string[] {
  return Array.from(messageHandlers.keys());
}

export function resetMessageBus(): void {
  messageHandlers.clear();
}
